import React, {useState, useEffect} from 'react'
import firebase from '../Services/firebase'
import {Typography, List, ListItemText, ListItem, ListItemIcon, Avatar, Tooltip,
    ListItemSecondaryAction, IconButton, Chip, Badge, ListItemAvatar, Divider} from '@material-ui/core'
import FaceIcon from '@material-ui/icons/Face'
import DoneIcon from '@material-ui/icons/Done'
import userService from '../Services/user'
import { makeStyles, withStyles } from '@material-ui/core/styles'

const StyledBadgeOnline = withStyles((theme) => ({
    badge: {
      backgroundColor: '#44b700',
      color: '#44b700',
      boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
      '&::after': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        content: '""',
      },
    },
  }))(Badge)

  const StyledBadgeOffline = withStyles((theme) => ({
    badge: {
      backgroundColor: '#faf2f2',
      color: '#faf2f2',
      boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
      '&::after': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        content: '""',
      },
    },
  }))(Badge)

  const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      '& > *': {
        margin: theme.spacing(1),
      },
    },
  }))

  

function Users(props) {
    const [aUsers, setAUsers]= useState([])
    const [uUsers, setUUsers]= useState([])
    const [userId, setUserId]= useState("")
    const [adminId, setAdminId]= useState("")

    useEffect(()=>{
        if(props.roomName){
            var dbRef = firebase.database().ref("/rooms/" + props.roomName + "/people")
            dbRef.on('value', function(snapshot) {

            var activePeople = []
            var unactivePeople = []

            snapshot.forEach(function (doc){
                var x = doc.val()
                if(x.status === "Online"){
                    activePeople.push(doc.val())
                } else{
                    unactivePeople.push(doc.val())
                }
                
            })
           // var people = activePeople.concat(unactivePeople)
            setAUsers(activePeople)
            setUUsers(unactivePeople)
           // console.log(activePeople)
            //console.log(unactivePeople)
            //console.log(people)
            })
        }

        if(props.userId){
           // console.log(props.userId)
            setUserId(props.userId)
        }
        
        if(props.adminId){
            setAdminId(props.adminId)
        }

        

    }, [props.roomName, props.userId, props.adminId])

    const ucFirstJS = (string) =>{
        return string.charAt(0).toUpperCase() + string.slice(1)
    }

    function randomColor() {
        let hex = Math.floor(Math.random() * 0xFFFFFF)
        let color = "#" + hex.toString(16)
      
        return color
      }


      function hashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
           hash = str.charCodeAt(i) + ((hash << 5) - hash)
        }
       // console.log(hash);
        return hash
    } 
    
    function intToRGB(i){
        var c = (i & 0x00FFFFFF)
            .toString(16)
            .toUpperCase()

           // console.log(c);
            return "#"+c
    
       // return "00000".substring(0, 6 - c.length) + c;
    }

    return (
        <div>
             <div>
                    <Typography>Active People</Typography>
            </div>
            <div>
                <List>
                    {aUsers.map((user, i)=>(
                        <ListItem key={i}>
                            <ListItemAvatar>
                                <StyledBadgeOnline
                                    overlap="circle"
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    }}
                                    variant="dot"
                                >
                                    <Avatar alt={user.name} src="/gg/gg.jpg" style={{backgroundColor: intToRGB(hashCode(user.userUID))}} />
                                </StyledBadgeOnline>
                            </ListItemAvatar>

                            <ListItemText 
                                id={"user-id"+i} 
                                primary={user.userUID == userId? (<Typography style={{color: 'purple'}}> {user.name}</Typography>) : (<Typography> {user.name} </Typography>)} 
                            />

                            <ListItemSecondaryAction>

                            {user.userUID === adminId ? ( 
                                <Tooltip title="Admin: Who Created this Room">
                                    <FaceIcon style={{color:'red'}} /> 
                                </Tooltip> ):
                                ( <FaceIcon /> )}

                            </ListItemSecondaryAction>


                        </ListItem>
                    ))} 

                    <div style={{margin: '10px 0px'}}>
                        <Divider />
                    </div>

                    {uUsers.map((user, i)=>(
                        <ListItem key={i}>
                            <ListItemAvatar>
                                <StyledBadgeOffline
                                    overlap="circle"
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    }}
                                    variant="dot"
                                >
                                    <Avatar alt={user.name} src="/gg/gg.jpg" style={{backgroundColor: intToRGB(hashCode(user.userUID))}} />
                                </StyledBadgeOffline>
                            </ListItemAvatar>

                            <ListItemText 
                                id={"user-id"+i} 
                                primary={user.name} 
                            />

                            <ListItemSecondaryAction>

                            {user.userUID === adminId ? ( 
                                <Tooltip title="Admin: Who Created this Room">
                                    <FaceIcon style={{color:'red'}} /> 
                                </Tooltip> ):
                                ( <FaceIcon /> )}
                            </ListItemSecondaryAction>


                        </ListItem>
                    ))} 
                </List>                      
            </div>
        </div>
    )
}

export default Users



// const gg = ()=>{
//     return (
//         <List dense={false}>  
//             <ListItem>
//                 <ListItemAvatar>
//                     <StyledBadge
//                         overlap="circle"
//                         anchorOrigin={{
//                             vertical: 'bottom',
//                             horizontal: 'right',
//                         }}
//                         variant="dot"
//                     >
//                         <Avatar alt={user.name} src="" style={{backgroundColor: randomColor()}} />
//                     </StyledBadge>
//                 </ListItemAvatar>
//                 <ListItemText
//                     primary="Single-line item"
//                     secondary={null}
//                 />

//                 <ListItemSecondaryAction>
//                     <IconButton edge="end" aria-label="delete">
//                       <FaceIcon />
//                     </IconButton>
//                 </ListItemSecondaryAction>
//             </ListItem>



                            {/* <ListItemIcon>
                                <StyledBadge
                                    overlap="circle"
                                    anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                    }}
                                    variant="dot"
                                >
                                    <Avatar alt={user.name} src="" style={{backgroundColor: randomColor()}} />
                                </StyledBadge>
                            </ListItemIcon> */}

                            {/* <ListItemText 
                            id={"user-id"+i} 
                            primary={user.name} /> */}

                        
                            

                            {/* {
                                user.userUID === userId ? (
                                    <Chip
                                        icon={<FaceIcon color="secondary"/>}
                                        label={user.userUID === adminId ? "IM Admin" : "Me"}
                                        clickable
                                        color={user.userUID === adminId ? "secondary" : "primary"}
                                        deleteIcon={<DoneIcon />}
                                        variant="outlined"
                                    />
                                ): (
                                    <Chip
                                        icon={<FaceIcon />}
                                        label={user.userUID === adminId ? "Admin" : "User"}
                                        clickable
                                        color={user.userUID === adminId ? "secondary" : "default"}
                                        deleteIcon={<DoneIcon />}
                                        variant="outlined"
                                    /> 
                                )
                            }

                            <p>{user.status}</p> */}
                            

                        {/* <ListItemSecondaryAction>
                            <IconButton edge="end" aria-label="delete">
                                <FaceIcon />
                            </IconButton>
                        </ListItemSecondaryAction> */}
//         </List>
//     )
// }
